import { StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native'
import { Palette, getInitials } from '@ppwr/poker'
import { fontFamily } from '../../../../theme'
import { PlayerCellVideo } from '../PlayerCellVideo'
import { useResponsive } from '@/screens/new-design/hooks'
import { DS } from '@/design-system'

// styles for video/initials according to number of players
const AVATAR_SIZES = {
  3: {
    width: 52,
    height: 52,
    borderRadius: 52,
    fontSize: 18
  },
  4: {
    width: 32,
    height: 32,
    borderRadius: 32,
    fontSize: 12
  },
  profile: {
    width: 48,
    height: 48,
    borderRadius: 48,
    fontSize: 12
  },
  default: {
    height: 72,
    width: 72,
    borderRadius: 72,
    fontSize: 20
  }
}

type AvatarSize = keyof typeof AVATAR_SIZES
type AvatarSizeConfig = (typeof AVATAR_SIZES)[AvatarSize]

interface VideoConfig {
  playerId: number
  right?: boolean
}

interface PlayerAvatarProps {
  name: string
  size?: AvatarSize
  containerStyle?: ViewStyle
  textStyle?: TextStyle
  video?: VideoConfig
  applyOpacity?: boolean
  textColor?: string
  backgroundColor?: string
}

export const Avatar = ({ name, containerStyle, textStyle, video, applyOpacity, textColor, backgroundColor }: PlayerAvatarProps) => {
  const { verticalScale } = useResponsive()
  const avatarSize = {
    width: 32,
    height: 32,
    borderRadius: 32,
    fontSize: 12
  }

  if (video)
    return (
      <PlayerAvatarVideo
        video={video}
        size={{
          ...avatarSize,
          height: verticalScale(avatarSize.height),
          width: verticalScale(avatarSize.width),
          fontSize: verticalScale(avatarSize.fontSize)
        }}
      />
    )

  return (
    <View
      style={[
        styles.container,
        avatarSize,
        { opacity: applyOpacity ? 0.4 : 1 },
        backgroundColor ? { backgroundColor } : undefined,
        containerStyle
      ]}
    >
      <Text style={[styles.text, { color: textColor ?? '#fff' }, textStyle]}>
        {getInitials(name, { withEmoji: false })}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: DS.palette['Shades/Maroon 2'],
    alignItems: 'center',
    justifyContent: 'center'
  },
  video: {
    width: 72,
    height: 72,
    borderRadius: 36,
    backgroundColor: Palette['Global/Black']
  },
  text: {
    textAlign: 'center',
    fontSize: 12,
    fontFamily: fontFamily.GTAmericaExtended,
    textTransform: 'uppercase'
  }
})

const PlayerAvatarVideo = ({ video, size }: { video: VideoConfig; size: AvatarSizeConfig }) => {
  const { playerId } = video
  return (
    <View style={[styles.video, size]}>
      <DS.Center>
        <PlayerCellVideo
          playerId={playerId}
          videoStyle={{ borderRadius: size.borderRadius, overflow: 'hidden', height: size.height, width: size.width }}
        />
      </DS.Center>
    </View>
  )
}
